import Serializable from "@/core/misc/mixins/Serializable";

class PaymentTermEvent extends Serializable {
    public id: string;
    public name: string;
    /** Тип оплаты: 'pre' — предоплата, 'post' — постоплата */
    public paymentType: 'pre' | 'post';

    static fromServer(data: any, result = new PaymentTermEvent()): PaymentTermEvent {
      super.fromServer(data, result);
      return result;
    }

    get isPrepayment(): boolean {
      // Временная затычка, потому что с бека не приходит почему-то paymentType в запросе заказа
      if (['before_shipment', 'after_order_confirm'].includes(this.id)) return true;

      return this.paymentType === 'pre';
    }

    get isPostpayment(): boolean {
      // Временная затычка, потому что с бека не приходит почему-то paymentType в запросе заказа
      if (['after_shipment', 'after_receiving'].includes(this.id)) return true;

      return this.paymentType === 'post';
    }
}

export default PaymentTermEvent;
